export default __webpack_public_path__ + "img/partnership1-0489adf583acfafba2e009cf9061d195.png";